import { DrawerItem } from "@gisce/oficina-virtual-components";
import { Email } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const NewsletterDrawerItem = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return <DrawerItem 
    icon={<Email />}
    label={t('common:text.newsletter_manage')}
    onClick={() => navigate(t('common:url.newsletter'))}
    selected={location.pathname == t('common:url.newsletter')}
  />
}

export default NewsletterDrawerItem;